// removed by extract-text-webpack-plugin
module.exports = {"TopArea":"TrdEdit__-loca-__3t7IL","ReturnButton":"TrdEdit__-loca-__Kw9nr","ReturnButtonHelper":"TrdEdit__-loca-__2eCfS","Image":"TrdEdit__-loca-__MVgm5","FileButton":"TrdEdit__-loca-__2huua","LoadingScreen":"TrdEdit__-loca-__2PFog","SpinnerLocation":"TrdEdit__-loca-__1I_cl","Show":"TrdEdit__-loca-__vgSnZ","Hide":"TrdEdit__-loca-__3SQ_7","Form":"TrdEdit__-loca-__3c5zr","SpaceBetween":"TrdEdit__-loca-__DVlwy","BottomArea":"TrdEdit__-loca-__2z1ig"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/TrdAdminFocus/TrdEdit/TrdEdit.css
// module id = 240
// module chunks = 0